// "use client";

// import api from "../api";
// import { User } from "./type";
// import {
//   setClientCookie,
//   getClientCookie,
//   deleteClientCookie,
// } from "../cookies/clientCookies";

// // Define the proper AuthResponse type with the data property
// interface AuthResponse {
//   status: string;
//   message?: string;
//   data?: {
//     token: string;
//     user: User;
//   };
// }

// class AuthService {
//   private readonly AUTH_TOKEN_KEY = "auth_token";
//   private readonly USER_COOKIE_KEY = "user_data";

//   async sendOtp(phone: string) {
//     return await api.req({
//       url: "/auth/send-otp",
//       method: api.Method.POST,
//       body: { phone },
//     });
//   }

//   async verifyOtp(phone: string, otp: string) {
//     try {
//       const response = await api.req<AuthResponse>({
//         url: "/auth/verify-otp",
//         method: api.Method.POST,
//         body: { phone, otp },
//       });

//       if (response.status === "success" && response.data) {
//         this.saveUserData(response.data);
//       }

//       return response;
//     } catch (error) {
//       console.error("Error verifying OTP:", error);
//       throw error;
//     }
//   }

//   // Helper method to save user data consistently across methods
//   private saveUserData(data: NonNullable<AuthResponse["data"]>) {
//     // Common cookie options with correct type for sameSite
//     const cookieOptions = {
//       path: "/",
//       sameSite: "strict" as const,
//       secure: import.meta.env.PROD,
//       maxAge: 1 * 24 * 60 * 60, // 1 day in seconds
//     };

//     // Store token in cookie
//     setClientCookie({
//       name: this.AUTH_TOKEN_KEY,
//       value: data.token,
//       options: cookieOptions,
//       isParse: false,
//       isCompress: false,
//     });

//     // Store user in cookie
//     setClientCookie({
//       name: this.USER_COOKIE_KEY,
//       value: JSON.stringify(data.user),
//       options: cookieOptions,
//       isParse: true,
//       isCompress: true,
//     });

//     // Keep localStorage for backward compatibility
//     localStorage.setItem("user", JSON.stringify(data.user));

//     console.log("User data saved:", data.user);
//   }

//   getUser(): User | null {
//     // Try to get user from cookie first
//     const userCookie = getClientCookie({
//       name: this.USER_COOKIE_KEY,
//       isParse: true,
//       isCompress: true,
//     });

//     if (userCookie) {
//       try {
//         return JSON.parse(userCookie);
//       } catch (e) {
//         console.error("Error parsing user cookie:", e);
//       }
//     }

//     // Fallback to localStorage for backward compatibility
//     const userStr = localStorage.getItem("user");
//     if (userStr) {
//       try {
//         return JSON.parse(userStr);
//       } catch (e) {
//         console.error("Error parsing user from localStorage:", e);
//         return null;
//       }
//     }

//     return null;
//   }

//   logout() {
//     // Clear both cookies
//     deleteClientCookie({ name: this.AUTH_TOKEN_KEY });
//     deleteClientCookie({ name: this.USER_COOKIE_KEY });

//     // Clear all localStorage (including auth-storage and other persistent state)
//     localStorage.clear();

//     // Clear sessionStorage as well
//     sessionStorage.clear();
//   }

//   isAuthenticated(): boolean {
//     const token = getClientCookie({
//       name: this.AUTH_TOKEN_KEY,
//       isParse: false,
//       isCompress: false,
//     });
//     return !!token;
//   }

//   async switchAccount(userIdentifier: string, clientUuid: string) {
//     try {
//       const response = await api.req<AuthResponse>({
//         url: "/auth/switch-account",
//         method: api.Method.POST,
//         body: { user_identifier: userIdentifier, client_uuid: clientUuid },
//       });

//       if (response.status === "success" && response.data) {
//         // Use the helper method to save user data consistently
//         this.saveUserData(response.data);
//         console.log("Account switched successfully to:", response.data.user);
//       }

//       return response;
//     } catch (error) {
//       console.error("Error switching account:", error);
//       throw error;
//     }
//   }
// }

// export const authService = new AuthService();


"use client";

import api from "../api";
import { User } from "./type";
import { fetchCurrentUser, clearUserCache } from "../../services/userService";

// Define the auth data type
interface AuthData {
  token: string;
  user: User;
}

class AuthService {
  // Use the same cookie names as used in Login.tsx and FacebookCallback.tsx
  private readonly AUTH_TOKEN_KEY = "crm_auth_token";
  private readonly USER_STORAGE_KEY = "crm_user"; // localStorage key, not cookie


  async sendOtp(phone: string) {
    return await api.req({
      url: "/auth/send-otp",
      method: api.Method.POST,
      body: { phone },
    });
  }

  async verifyOtp(phone: string, otp: string) {
    try {
      const response = await api.req<AuthData>({
        url: "/auth/verify-otp",
        method: api.Method.POST,
        body: { phone, otp },
      });

      if (response.status === "success" && response.data) {
        this.saveUserData(response.data);
      }

      return response;
    } catch (error) {
      console.error("Error verifying OTP:", error);
      throw error;
    }
  }

  // Helper method to save user data consistently across methods
  private saveUserData(data: AuthData) {
    // Get cookie domain - must match Login.tsx (services/authService.ts) domain logic
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    const isSecure = typeof window !== 'undefined' && window.location.protocol === 'https:';
    const cookieDomain = hostname.includes('yellowslate.com') ? '.yellowslate.com' :
                        hostname.includes('localhost') ? '' :
                        '';

    console.log('Saving user data:', {
      hostname,
      cookieDomain,
      clientUuid: data.user.client_uuid,
      clientName: data.user.client_name,
      userName: data.user.name
    });

    // Set domain so cookie is accessible across subdomains
    const domainAttr = cookieDomain ? `; domain=${cookieDomain}` : '';
    const secureAttr = isSecure ? '; Secure' : '';

    const cookieString = `${this.AUTH_TOKEN_KEY}=${data.token}; max-age=${7 * 24 * 60 * 60}; path=/${domainAttr}; SameSite=Lax${secureAttr}`;
    document.cookie = cookieString;

    console.log('Cookie set:', cookieString.substring(0, 100) + '...');

    // Store user in localStorage (matching Login.tsx approach)
    if (typeof window !== 'undefined') {
      localStorage.setItem(this.USER_STORAGE_KEY, JSON.stringify(data.user));
      console.log('💾 User stored in localStorage');
    }

    console.log("✅ User data saved successfully:", data.user.name);
  }

  getUser(): User | null {
    // Get user from localStorage (matching Login.tsx approach)
    if (typeof window !== 'undefined') {
      const userStr = localStorage.getItem(this.USER_STORAGE_KEY);
      if (userStr) {
        try {
          return JSON.parse(userStr);
        } catch (e) {
          console.error("Error parsing user from localStorage:", e);
          return null;
        }
      }
    }

    return null;
  }

  getToken(): string | null {
    // Get token from cookie using simple cookie parsing (matching optimized-api.ts)
    if (typeof document !== 'undefined') {
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === this.AUTH_TOKEN_KEY) {
          return value;
        }
      }
    }
    return null;
  }

  logout() {
    // List of all known cookies to clear
    const cookiesToClear = [
      'crm_auth_token',
      'crm_session_id',
      'token',
      'user_info',
      'social_plan_details'
    ];

    // Get cookie domain - must match Login.tsx (services/authService.ts) domain logic
    const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
    const cookieDomain = hostname.includes('yellowslate.com') ? '.yellowslate.com' :
                        hostname.includes('localhost') ? 'localhost' :
                        hostname;

    // Clear all known cookies with multiple domain/path combinations
    cookiesToClear.forEach(cookieName => {
      document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
      document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${cookieDomain}`;
      if (cookieDomain.startsWith('.')) {
        document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${cookieDomain.substring(1)}`;
      }
    });

    // Clear user data from localStorage
    if (typeof window !== 'undefined') {
      // Clear all known localStorage keys (keeping UI preferences like column visibility)
      const keysToExplicitlyClear = [
        'crm_user_data',
        'crm_user',
        'crm_auth_token',
        'crm_user_column_preferences',
        'crm_tour_leads_auto_started',
        'crm_tour_pipeline_auto_started',
        'crm_tour_leads_completed',
        'crm_tour_pipeline_completed',
        'crm_previous_account', // Clear previous account marker on logout
        'user',
        'token'
      ];

      keysToExplicitlyClear.forEach(key => {
        localStorage.removeItem(key);
      });

      // Clear sessionStorage as well
      sessionStorage.clear();
    }

    // Clear shared /me request cache
    clearUserCache();
  }

  isAuthenticated(): boolean {
    const token = this.getToken();
    const user = this.getUser();
    return !!(token && user);
  }


  async validateToken(): Promise<boolean> {
    try {
      // Use fetchCurrentUser which has module-level in-flight deduplication and 5s cache.
      // This means RouteGuard and UserContext share a single /me request.
      const response = await fetchCurrentUser();

      if (response && response.data?.data && typeof window !== 'undefined') {
        localStorage.setItem(this.USER_STORAGE_KEY, JSON.stringify(response.data.data));
      }

      return !!response;
    } catch (error) {
      console.error('Token validation failed:', error);
      return false;
    }
  }

  // Method to get user profile from API (server-side caching via Redis)
  async getUserProfile(): Promise<User | null> {
    try {
      console.log('Fetching user profile from API (server-cached)');
      const response = await api.req<User>({
        url: "/users/me",
        method: api.Method.GET,
      });

      if (response && response.data) {
        const user = response.data as User;

        // Update the user in localStorage for consistency
        if (typeof window !== 'undefined') {
          localStorage.setItem(this.USER_STORAGE_KEY, JSON.stringify(user));
        }

        return user;
      }

      return null;
    } catch (error) {
      console.error('Error fetching user profile:', error);
      return null;
    }
  }

  async switchAccount(email: string, clientUuid: string) {
    try {
      // Store the current account info before switching (for "return to previous account" feature)
      const currentUser = this.getUser();
      if (currentUser && typeof window !== 'undefined') {
        const previousAccount = {
          client_uuid: currentUser.client_uuid,
          client_name: currentUser.client_name,
          user_name: currentUser.name,
          switched_at: new Date().toISOString()
        };
        localStorage.setItem('crm_previous_account', JSON.stringify(previousAccount));
        console.log('💾 Stored previous account for quick return:', previousAccount);
      }

      const response = await api.req<AuthData>({
        url: "/auth/switch-account",
        method: api.Method.POST,
        body: { email, client_uuid: clientUuid },
      });

      if (response.status === "success" && response.data) {
        // IMPORTANT: Clear all client-specific localStorage before switching
        // This prevents preferences from the old account persisting
        if (typeof window !== 'undefined') {
          const keysToRemoveOnSwitch = [
            'crm_user_column_preferences',
            'crm_tour_leads_auto_started',
            'crm_tour_pipeline_auto_started'
          ];

          keysToRemoveOnSwitch.forEach(key => {
            localStorage.removeItem(key);
          });

          console.log("✅ Cleared old account data before switching");
        }

        // Use the helper method to save user data consistently
        this.saveUserData(response.data);
        console.log("Account switched successfully to:", response.data.user);
      }

      return response;
    } catch (error) {
      console.error("Error switching account:", error);
      throw error;
    }
  }

  // Get previous account info (if user switched from another account)
  getPreviousAccount(): { client_uuid: string; client_name: string; user_name: string; switched_at: string } | null {
    if (typeof window !== 'undefined') {
      const data = localStorage.getItem('crm_previous_account');
      if (data) {
        try {
          return JSON.parse(data);
        } catch (error) {
          console.error('Error parsing previous account data:', error);
          return null;
        }
      }
    }
    return null;
  }

  // Clear previous account info (called after returning to it or on regular logout)
  clearPreviousAccount(): void {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('crm_previous_account');
    }
  }

  // Quick return to previous account (one-click switch back)
  async returnToPreviousAccount(email: string): Promise<any> {
    const previousAccount = this.getPreviousAccount();
    if (!previousAccount) {
      throw new Error('No previous account found');
    }

    try {
      // Switch back to previous account
      const response = await this.switchAccount(email, previousAccount.client_uuid);

      // Clear the previous account marker since we're back
      this.clearPreviousAccount();

      return response;
    } catch (error) {
      console.error('Error returning to previous account:', error);
      throw error;
    }
  }
}

export const authService = new AuthService();